<div class="content">
  <span class="start-when">
    <strong>
      {{ 'AUTOMATIONS.EDITOR.TASKS.DELAY_UNTIL_EVENT.DELAY_UNTIL_EVENT' | translate }}
    </strong>
  </span>
  <div class="subtitle description">
    {{ 'AUTOMATIONS.EDITOR.TASKS.DELAY_UNTIL_EVENT.WORKFLOW_STEP_SUBTITLE' | translate }}
    <div *ngIf="currentStep !== 'selectWorkflowStep'">
      <div [innerHtml]="waitForDataDisplay$ | async"></div>
    </div>
  </div>

  <div *ngIf="currentStep === 'selectWorkflowStep'">
    <div
      class="workflow-data-container"
      *ngIf="workflowStepOutputParameterContainers$ | async as workflowStepOutputParameterContainers; else loading"
    >
      <div
        class="subtitle description"
        [innerHtml]="
          'AUTOMATIONS.EDITOR.TASKS.DELAY_UNTIL_EVENT.WORKFLOW_STEP_DESCRIPTION' | translate | iTrustThisHtml
        "
      ></div>
      <automata-output-parameter-selector
        [dataValueThatReferencesAPreviousStep]="step?.waitForTriggerFilter?.value"
        [workflowStepOutputParameterContainers]="workflowStepOutputParameterContainers"
        [defaultDataType]="triggerParamDataType"
        (valueSelected)="outputParamSelected($event)"
        [supportedDataTypes]="validDelayUntilDataTypes"
      ></automata-output-parameter-selector>
    </div>
  </div>

  <automata-trigger-editor-control
    #triggerEditorControl
    [hidden]="currentStep !== 'selectTrigger'"
    [automation]="automation"
    [taskDefinitionId]="waitForTriggerTaskDefinitionId"
    [step]="step"
    [triggerChoices]="step?.choices"
    [waitForEventData]="selectedStepsData"
    [isWaitingForEvent]="true"
    [waitForDataType]="selectedOutputParam?.settings?.dataType"
    (triggerCleared)="triggerCleared()"
  ></automata-trigger-editor-control>
  <div class="delay-container" *ngIf="!!triggerEditorControl?.taskDefinitionId && currentStep === 'selectTrigger'">
    <div class="title description">
      {{ 'AUTOMATIONS.EDITOR.TASKS.DELAY_UNTIL_EVENT.TIME_LIMIT' | translate }}
    </div>
    <div class="subtitle description">
      {{ 'AUTOMATIONS.EDITOR.TASKS.DELAY_UNTIL_EVENT.TIME_LIMIT_DESCRIPTION' | translate }}
    </div>
    <form [formGroup]="form">
      <automata-delay-control
        [form]="form"
        [waitLabelTranslationKey]="'AUTOMATIONS.EDITOR.TASKS.DELAY_UNTIL_EVENT.WAIT_UP_TO'"
        [sleep]="step?.sleep || 0"
      ></automata-delay-control>
    </form>
  </div>
</div>

<ng-template #loading>
  <div class="side-drawer-shimmer-container">
    <span class="selector stencil-shimmer"></span>
  </div>
</ng-template>
